/**
 * Mobile sticky ATC bar.
 *  - Watches the main buy_buttons block; shows the bottom bar when the main
 *    ATC scrolls out of view.
 *  - When tapped, syncs the chosen variant into the main product form and
 *    submits it, so cart behavior (ajax cart drawer, line item properties,
 *    Shop integrations) is identical to the main flow.
 */
(function () {
  if (window.matchMedia('(min-width: 768px)').matches) return;

  const bar = document.querySelector('[data-pdp-mobile-atc]');
  if (!bar) return;

  const mainBuy =
    document.querySelector('.product-single__box__block--buy_buttons') ||
    document.querySelector('.product-form__cart-submit') ||
    document.querySelector('[name="add"]');
  if (!mainBuy) return;

  const variantSelect = bar.querySelector('[data-pdp-mobile-atc-variant]');
  const submitBtn = bar.querySelector('[data-pdp-mobile-atc-submit]');
  const label = bar.querySelector('[data-pdp-mobile-atc-label]');
  const formId = submitBtn.getAttribute('data-form-id');
  const form = document.getElementById(formId);

  if (!form) {
    console.warn('[pdp-mobile-atc] product form not found:', formId);
    return;
  }

  // ----- visibility -----
  const observer = new IntersectionObserver(
    function (entries) {
      const entry = entries[0];
      if (entry.isIntersecting) {
        bar.classList.remove('is-visible');
        bar.setAttribute('aria-hidden', 'true');
      } else {
        bar.classList.add('is-visible');
        bar.setAttribute('aria-hidden', 'false');
      }
    },
    { threshold: 0.05 }
  );
  observer.observe(mainBuy);

  // ----- variant sync from main form into bar -----
  function getMainSelectedVariantId() {
    const id =
      form.querySelector('[name="id"]:checked') ||
      form.querySelector('select[name="id"]') ||
      form.querySelector('input[name="id"]');
    return id ? id.value : null;
  }

  function updateLabel() {
    if (!variantSelect) return;
    const opt = variantSelect.options[variantSelect.selectedIndex];
    if (!opt) return;
    if (opt.disabled) {
      label.textContent = 'Sold out';
      submitBtn.disabled = true;
    } else {
      submitBtn.disabled = false;
      const priceMatch = opt.textContent.match(/\$[0-9.,]+/);
      label.textContent = priceMatch ? 'Add — ' + priceMatch[0] : 'Add to cart';
    }
  }

  if (variantSelect) {
    variantSelect.addEventListener('change', function () {
      const mainSelect = form.querySelector('select[name="id"]');
      const mainRadios = form.querySelectorAll('input[name="id"]');
      if (mainSelect) {
        mainSelect.value = variantSelect.value;
        mainSelect.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (mainRadios.length) {
        mainRadios.forEach(function (r) {
          r.checked = r.value === variantSelect.value;
        });
      }
      updateLabel();
    });
    updateLabel();
  }

  // Keep bar in sync if user picks variant via main swatches/buttons
  form.addEventListener('change', function () {
    if (!variantSelect) return;
    const mainId = getMainSelectedVariantId();
    if (mainId && mainId !== variantSelect.value) {
      variantSelect.value = mainId;
      updateLabel();
    }
  });

  // ----- submit -----
  submitBtn.addEventListener('click', function () {
    // Prefer the existing ATC button so the theme's ajax-cart handler runs.
    const mainAtc =
      form.querySelector('.product-form__cart-submit') ||
      form.querySelector('[name="add"]');
    if (mainAtc) {
      mainAtc.click();
    } else {
      form.submit();
    }
  });
})();
